<div class="sh-form-tag-list">
    <div class="sh-form-tag-list__input">
        <ng-container *ngTemplateOutlet="inputField"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="tagList"></ng-container>
    <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
</div>

<ng-template #inputField>
    <div class="sh-input-field-with-action">
        <div class="sh-input-field-with-action__input">
            <med-thesaurus-search
                #search
                [thesaurusSearchControl]="thesaurusSearchControl"
                [thesaurusDefDottedKey]="thesaurusDefDottedKey"
                [multiple]="multiple"
                [enableSuggestions]="enableSuggestions"
                [indeterminateMsg]="'general.different-values' | translate"
                [disabledMsg]="disabledMsg"
                [setValue]="synchronizeConceptSelection$ | async"
                (selectedConcept)="onLookupSelection($event)"
                (suggestion)="onSuggestion($event)"
            ></med-thesaurus-search>
        </div>
        <sh-action-item
            *ngIf="selectValuesActionItem$ | async as selectValuesActionItem"
            class="sh-input-field-with-action__action"
            [item]="selectValuesActionItem"
        >
        </sh-action-item>
    </div>
</ng-template>

<ng-template #tagList>
    <med-thesaurus-tag-list
        *ngIf="(tags$ | async)?.options.length > 0 || (this.suggestedConcepts$ | async)?.length > 0; else noValues"
        [id]="id"
        [disabled]="disabled"
        [multiple]="multiple"
        [placeholderMsg]="placeholderMsg"
        [tags]="tags$ | async"
        [suggestions]="suggestedConcepts$ | async"
        (valueRemoved)="removeValue($event)"
        (suggestionRemoved)="removeSuggestion($event)"
    >
    </med-thesaurus-tag-list>
</ng-template>

<ng-template #errorMessages>
    <p *ngIf="suggestionErrorMsg$ | async as suggestionErrorMsg" [style]="'color: red;'" class="sh-form-group__feedback">
        <sh-html-parser [message]="suggestionErrorMsg"></sh-html-parser>
    </p>
    <p *ngIf="(isIndeterminate$ | async) && multiple" class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
</ng-template>

<ng-template #noValues>
    <p class="sh-clear-margin">{{ placeholderMsg }}</p>
</ng-template>
